module.exports = __webpack_public_path__ + "img/styleBlack.28c9c96c.svg";